// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "7c537497",
    "hash": "7c537497",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "7c537497",
    "semverString": null,
    "version": "2026.7.0.2"
};
/* tslint:enable */
